<main class="carConfig">
  <!-- continuar -->
  <div
    class="content--btnContainer"
    *ngIf="
      requestType === requestTypeEnum.dotArr ||
      requestType === requestTypeEnum.leasing
    "
  >
    <button
      [disabled]="quotaError || (isVip && !vehicleInfoData)"
      class="content--btnContainer__btn"
      mat-button
      (click)="nextStep()"
      [style]="
        quotaError || (isVip && !vehicleInfoData)
          ? 'opacity: 0.4'
          : 'opacity: 1.0'
      "
    >
      {{ 'validConfig' | i18next | uppercase }}
    </button>
    <button
      class="content--btnContainer__btn content--btnContainer__btn__back"
      [style]="'background-color: #2c2a29; display: flex; align-items: center; gap: 0.5rem'"
      mat-button
      (click)="backStep()"
    >
      <mat-icon class="icon">arrow_back</mat-icon>
      {{ 'goBackConfig' | i18next | uppercase }}
    </button>
  </div>
  <form [formGroup]="configCarform">
    <section
      class="carConfig--vehicleType"
      *ngIf="
        requestType !== requestTypeEnum.didactic &&
        requestType !== requestTypeEnum.innerRoute &&
        requestType !== requestTypeEnum.loan &&
        requestType !== requestTypeEnum.dotArr &&
        requestType !== requestTypeEnum.leasing
      "
    >
      <h5 class="carConfig--vehicleType__title">
        {{ 'requestVehicleType' | i18next }}
      </h5>
      <div class="carConfig--vehicleType__radioGroup">
        <mat-radio-group
          class="carConfig--vehicleType__radioGroup--form"
          formControlName="type"
          color="primary"
        >
          <mat-radio-button
            class="carConfig--vehicleType__radioGroup--item"
            *ngIf="requestType !== requestTypeEnum.generalServices"
            value="configurator"
            >{{ 'fleetVehicle' | i18next }}</mat-radio-button
          >
          <mat-radio-button
            *ngIf="requestType !== requestTypeEnum.generalServices"
            class="carConfig--vehicleType__radioGroup--item"
            value="stock"
            >{{ 'stockVehicle' | i18next }}</mat-radio-button
          >
          <mat-radio-button
            class="carConfig--vehicleType__radioGroup--item"
            *ngIf="requestType === requestTypeEnum.generalServices"
            value="newFabric"
            >{{ 'newManufacturing' | i18next }}</mat-radio-button
          >
          <mat-radio-button
            *ngIf="requestType === requestTypeEnum.generalServices"
            class="carConfig--vehicleType__radioGroup--item"
            value="flota"
            >{{ 'gsOriginFlota' | i18next }}</mat-radio-button
          >
        </mat-radio-group>
      </div>
    </section>
    <section
      class="carConfig--newVehicle"
      *ngIf="
        configCarform.value.type === 'configurator' &&
        requestType !== requestTypeEnum.didactic &&
        requestType !== requestTypeEnum.generalServices &&
        requestType !== requestTypeEnum.innerRoute &&
        requestType !== requestTypeEnum.loan
      "
    >
      <app-car-configurator
        (carConfigInfoEmitter)="carConfigInfoUpdadte($event)"
        (configCodeEmitter)="updateCodeConfig($event)"
        (quotaEmitter)="exceededQuota($event)"
        (maxQuotaEmit)="getMaxQuota($event)"
        (pccErrorEmitter)="updateErrorPcc($event)"
        (showVehicleInfo)="showVehicleInfo($event)"
        (nextStep)="nextStep($event)"
        [isDetail]="isDetail"
        [vehicleType]="requestType"
        [isVip]="isVip"
      ></app-car-configurator>
    </section>
    <section
      *ngIf="
        configCarform.value.type === 'stock' &&
        requestType !== requestTypeEnum.didactic &&
        requestType !== requestTypeEnum.generalServices &&
        requestType !== requestTypeEnum.innerRoute &&
        requestType !== requestTypeEnum.loan
      "
    >
      <app-stock-vehicles
        (selectedVehicleChange)="onStockVehicleChange($event)"
        [requestType]="requestType"
      ></app-stock-vehicles>
    </section>
    <small class="error" *ngIf="vehicleInfoData && quotaError">{{
      'errorExCuota' | i18next
    }}</small>

    <!-- Tipo servicios generales -->
    <section
      class="carConfig--vehicleType"
      *ngIf="
        configCarform.value.type === 'newFabric' &&
        requestType === requestTypeEnum.generalServices
      "
    >
      <h5 class="carConfig--vehicleType__title">
        {{ 'gsSelectNewFabricOpts' | i18next }}
      </h5>
      <div class="carConfig--vehicleType__radioGroup">
        <mat-radio-group
          class="carConfig--vehicleType__radioGroup--form"
          formControlName="subtype"
          color="primary"
        >
          <mat-radio-button
            value="configVehicle"
            class="carConfig--vehicleType__radioGroup--item"
            >{{ 'fleetVehicle' | i18next }}</mat-radio-button
          >
          <mat-radio-button
            class="carConfig--vehicleType__radioGroup--item"
            value="stock"
            >{{ 'stockVehicle' | i18next }}</mat-radio-button
          >
        </mat-radio-group>
      </div>
    </section>
    <!-- vehiculo nuevo -->
    <section
      class="carConfig--newVehicle"
      *ngIf="
        configCarform.value.type === 'newFabric' &&
        requestType === requestTypeEnum.generalServices
      "
    >
      <app-car-configurator
        *ngIf="
          configCarform.value.type === 'newFabric' &&
          configCarform.value.subtype === 'configVehicle'
        "
        (carConfigInfoEmitter)="carConfigInfoUpdadte($event)"
        (configCodeEmitter)="updateCodeConfig($event)"
        (quotaEmitter)="exceededQuota($event)"
        (pccErrorEmitter)="updateErrorPcc($event)"
        [isDetail]="isDetail"
        [vehicleType]="requestType"
      ></app-car-configurator>
      <app-stock-vehicles
        *ngIf="
          configCarform.value.type === 'newFabric' &&
          configCarform.value.subtype === 'stock'
        "
        (selectedVehicleChange)="onStockVehicleChange($event)"
        [requestType]="requestType"
      ></app-stock-vehicles>
    </section>
    <!-- lista stock -->
    <section
      class="carConfig--vehicleType"
      *ngIf="
        configCarform.value.type === 'flota' &&
        requestType === requestTypeEnum.generalServices
      "
    >
      <h5 class="carConfig--vehicleType__title">
        {{ 'gsSelectStockModels' | i18next }}
      </h5>
      <div class="carConfig--vehicleType__checkboxContainer">
        <mat-checkbox
          color="primary"
          [checked]="modelListSelected.includes(model.name)"
          *ngFor="let model of modelList"
          [value]="model.name"
          (change)="changeModel(model.name)"
          >{{ model.name }}</mat-checkbox
        >
      </div>
      <div class="carConfig--vehicleType__checkboxInfo">
        <small>{{ 'gsFlotaText' | i18next }}</small>
      </div>
    </section>
  </form>
  <!-- Tipo didactico / educational -->
  <form
    [formGroup]="innerRouteForm"
    class="carConfig--didactic"
    *ngIf="requestType === requestTypeEnum.innerRoute"
  >
    <section class="carConfig--vehicleType">
      <h5 class="carConfig--vehicleType__title">
        {{ 'selectModelText' | i18next }}
      </h5>
      <div class="carConfig--didactic__section">
        <mat-form-field>
          <mat-label required>{{ 'model' | i18next }}</mat-label>
          <mat-select formControlName="model">
            <mat-option
              *ngFor="let option of modelList"
              [value]="option.name"
              >{{ option.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="carConfig--vehicleType__selectModelText">
        <small>{{ 'modelAvalabilityText' | i18next }}</small>
      </div>
    </section>
  </form>
  <form [formGroup]="educationalForm" class="carConfig--didactic">
    <section
      class="carConfig--vehicleType"
      *ngIf="requestType === requestTypeEnum.didactic"
    >
      <h5 class="carConfig--vehicleType__title">
        {{ 'selectModelText' | i18next }}
      </h5>
      <div class="carConfig--didactic__section">
        <mat-form-field>
          <mat-label required>{{ 'model' | i18next }}</mat-label>
          <mat-select formControlName="model">
            <mat-option
              *ngFor="let option of modelList"
              [value]="option.name"
              >{{ option.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="carConfig--vehicleType__selectModelText">
        <small>{{ 'modelAvalabilityText' | i18next }}</small>
      </div>
    </section>
    <section
      class="carConfig--vehicleType"
      *ngIf="requestType === requestTypeEnum.didactic"
    >
      <h5 class="carConfig--vehicleType__title">
        {{ 'selectUsePropulsion' | i18next }}
      </h5>
      <div class="carConfig--didactic__section">
        <div class="carConfig--didactic__section--item">
          <mat-form-field class="use--container__selectField">
            <mat-label required>{{ 'didacticUse' | i18next }}</mat-label>
            <mat-select formControlName="use" (valueChange)="changeUse()">
              <mat-option
                *ngFor="let option of useOptionsEnum"
                [value]="option"
                >{{
                  option === 'DONATION' ? 'Donación' : 'Interno'
                }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="carConfig--didactic__section--item">
          <mat-form-field class="use--container__selectField">
            <mat-label required>{{ 'fuel' | i18next }}</mat-label>
            <mat-select
              formControlName="propulsion"
              (selectionChange)="changeFuel()"
            >
              <mat-option *ngFor="let option of fuelTypeEnum" [value]="option">
                {{ setFuelTypeText(option) }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </section>
    <section
      class="carConfig--vehicleType"
      *ngIf="requestType === requestTypeEnum.didactic"
    >
      <h5 class="carConfig--vehicleType__title">
        {{ 'didacticReasons' | i18next }}
      </h5>
      <div>
        <textarea
          class="textarea"
          formControlName="reason"
          name="reason"
          rows="3"
          cols="100"
          placeholder="Motivo"
        >
        </textarea>
      </div>
      <div class="error">
        <small
          *ngIf="
            educationalForm.controls['reason'].invalid &&
            educationalForm.controls['reason'].touched
          "
          >{{ 'writeReason' | i18next }}</small
        >
      </div>
    </section>
    <section
      class="carConfig--vehicleType"
      *ngIf="requestType === requestTypeEnum.didactic"
    >
      <h5 class="carConfig--vehicleType__title">
        {{ 'didacticEspecifications' | i18next }}
      </h5>
      <div>
        <textarea
          class="textarea"
          formControlName="specifications"
          name="specifications"
          rows="3"
          cols="100"
          placeholder="Especificaciones"
        >
        </textarea>
      </div>
      <div class="error">
        <small
          *ngIf="
            educationalForm.controls['specifications'].invalid &&
            educationalForm.controls['specifications'].touched
          "
          >{{ 'writeSpecification' | i18next }}</small
        >
      </div>
    </section>
  </form>
  <!-- PRESTAMOS -->
  <section
    class="carConfig--vehicleType"
    *ngIf="requestType === requestTypeEnum.loan"
  >
    <div *ngIf="loanType !== loanOptions.CP">
      <h5 class="carConfig--vehicleType__title">
        {{ 'selectModelText' | i18next }}
      </h5>
      <form
        [formGroup]="loanForm"
        class="carConfig--vehicleType__selectModelStock"
        *ngIf="stockVin === false && loanType !== loanOptions.CP"
      >
        <mat-form-field>
          <mat-label for="model" class="loan-request--label">{{
            'model' | i18next
          }}</mat-label>
          <mat-select
            name="model"
            formControlName="model"
            (change)="changeStockModel()"
          >
            <mat-option value="empty">{{
              'loanSelectType' | i18next
            }}</mat-option>
            <mat-option
              *ngFor="let option of modelList"
              [value]="option"
              (onSelectionChange)="updateLoanQuota($event)"
            >
              {{ option.name }} / {{ option.loanQuota }}€
            </mat-option>
          </mat-select>
        </mat-form-field>
        <small class="error-message" *ngIf="modelError">{{
          'selectModel' | i18next
        }}</small>
      </form>
      <div class="carConfig--vehicleType__selectModelStock--info">
        <small class="small">{{ 'modelAvalabilityText' | i18next }}</small>
      </div>
      <div class="carConfig--vehicleType__selectModelStock--info">
        <div class="loan-request--column">
          <label for="model" class="loan-request--label">{{
            'daysTotalCost' | i18next
          }}</label>
          <p class="loan-request--textArea">
            {{ valueText }}
          </p>
        </div>
      </div>
    </div>
    <app-stock-vehicles
      *ngIf="loanType === loanOptions.CP && stockModel === false"
      (selectedVehicleChange)="onStockVehicleChange($event)"
      [requestType]="requestTypeEnum.loan"
      [carPoolCenterDate]="carPoolCenterDate"
    ></app-stock-vehicles>
  </section>
  <!-- continuar -->
  <div
    class="content--btnContainer"
    *ngIf="
      requestType !== requestTypeEnum.dotArr &&
      requestType !== requestTypeEnum.leasing &&
      configCarform.value.type !== 'configurator' &&
      configCarform.value.subtype !== 'configVehicle'
    "
  >
    <button
      *ngIf="requestType !== requestTypeEnum.generalServices"
      [disabled]="
        (requestType !== requestTypeEnum.didactic &&
          configCarform.value.type === 'stock' &&
          !stockVehicle) ||
        (loanType === loanOptions.CP && !stockVehicle) ||
        (requestType === requestTypeEnum.didactic && educationalForm.invalid) ||
        quotaError ||
        innerRouteForm.status === 'INVALID'
      "
      class="content--btnContainer__btn"
      mat-button
      (click)="nextStep()"
      [style]="
        (requestType !== requestTypeEnum.didactic &&
          configCarform.value.type === 'stock' &&
          !stockVehicle) ||
        (loanType === loanOptions.CP && !stockVehicle) ||
        (requestType === requestTypeEnum.didactic && educationalForm.invalid) ||
        quotaError ||
        innerRouteForm.status === 'INVALID'
          ? 'opacity: 0.4'
          : 'opacity: 1.0'
      "
    >
      {{ 'buttonContinue' | i18next | uppercase }}
    </button>
    <button
      *ngIf="requestType === requestTypeEnum.generalServices"
      [disabled]="
        (configCarform.value.type === 'newFabric' &&
          configCarform.value.subtype === 'stock' &&
          !stockVehicle) ||
        (configCarform.value.type === 'flota' && modelListSelected.length === 0)
      "
      class="content--btnContainer__btn"
      mat-button
      (click)="nextStep()"
      [style]="
        (configCarform.value.type === 'newFabric' &&
          configCarform.value.subtype === 'stock' &&
          !stockVehicle) ||
        (configCarform.value.type === 'flota' && modelListSelected.length === 0)
          ? 'opacity: 0.4'
          : 'opacity: 1.0'
      "
    >
      {{ 'buttonContinue' | i18next | uppercase }}
    </button>
    <button
      class="content--btnContainer__btn content--btnContainer__btn__back"
      [style]="'background-color: #2c2a29; display: flex; align-items: center; gap: 0.5rem'"
      mat-button
      (click)="backStep()"
    >
      <mat-icon class="icon">arrow_back</mat-icon>
      {{ 'btnReturn' | i18next | uppercase }}
    </button>
  </div>
  <div
    class="content--btnContainer"
    *ngIf="
      (requestType === requestTypeEnum.dotArr &&
        configCarform.value.type === 'configurator') ||
      (requestType === requestTypeEnum.leasing &&
        configCarform.value.type === 'configurator') ||
      (configCarform.value.type === 'newFabric' &&
        configCarform.value.subtype !== 'stock' &&
        requestType === requestTypeEnum.generalServices) ||
      (configCarform.value.type !== 'stock' &&
        requestType === requestTypeEnum.function)
    "
  >
    <button
      class="content--btnContainer__btn"
      mat-button
      (click)="nextStep()"
      [disabled]="isVip && !vehicleInfoData"
      [style]="isVip && !vehicleInfoData ? 'opacity: 0.4' : 'opacity: 1.0'"
    >
      {{ 'validConfig' | i18next | uppercase }}
    </button>
    <button
      class="content--btnContainer__btn content--btnContainer__btn__back"
      [style]="'background-color: #2c2a29; display: flex; align-items: center; gap: 0.5rem'"
      mat-button
      (click)="backStep()"
    >
      <mat-icon class="icon">arrow_back</mat-icon>
      {{ 'goBackConfig' | i18next | uppercase }}
    </button>
  </div>
</main>
